var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2H17C18.5977 2 19.9037 3.24892 19.9949 4.82373L20 5L20.0009 8.17102C21.1656 8.58312 22 9.69412 22 11V13C22 14.3059 21.1656 15.4169 20.0009 15.829L20 19C20 20.5977 18.7511 21.9037 17.1763 21.9949L17 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H17H5ZM17 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H17C17.5128 20 17.9355 19.614 17.9933 19.1166L18 19V16H17C15.3431 16 14 14.6569 14 13V11C14 9.34315 15.3431 8 17 8H18V5C18 4.48716 17.614 4.06449 17.1166 4.00673L17 4ZM19 10H17C16.4477 10 16 10.4477 16 11V13C16 13.5523 16.4477 14 17 14H19C19.5523 14 20 13.5523 20 13V11C20 10.4477 19.5523 10 19 10Z",
    fill: "#0275D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransb);
export default __webpack_public_path__ + "static/media/transb.5ce115f972cf488e38fc3731b57a9768.svg";
export { ForwardRef as ReactComponent };